import React from 'react';

const Item = ({ value, text }) => (
  <option value={value}>{text}</option>
);

const SelectInput = props => (
  <select
    name={`${props.groupName}[${props.name}]`}
    className={props.className}
    value={props.selected}
    onChange={props.onChange}>
    {props.options.map(item => <Item key={item.value} {...item} />)}
  </select>
);

SelectInput.defaultProps = {
  name     : '',
  groupName: 'parameters',
  className: 'form-control form-select',
  options  : [],
};

export default SelectInput;
